/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import type { JSX } from 'react';

import './ContentEditable.scss';

import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import clsx from 'clsx';


type Props = {
  className?: string;
  placeholderClassName?: string;
  placeholder: string;
};

export function LexicalContentEditable({
  className,
  placeholder = 'Add your content here...',
  placeholderClassName
}: Readonly<Props>): JSX.Element {
  return (
    <ContentEditable
      className={clsx(
        // "lg:w-[70%]",
        // "lg:max-w-[750px]",
        // "lg:px-8 mx-auto",
        className ?? 'ContentEditable__root'
      )}
      aria-placeholder={placeholder}
      placeholder={
        <div className={placeholderClassName ?? 'ContentEditable__placeholder'}>
          {placeholder}
        </div>
      }
    />
  );
}
